<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  onMount(async () => {
    await fetch('/authentication/GetUserDetails')
    .then(res => res.json())
    .then(res => {
      const user = res.Result;

      let redirectTarget = '/reports/hours';
      if (user.Team !== 100000005) {
        redirectTarget = '/reports/pto';
      }

      navigate(redirectTarget, { replace: true });
    })
  });

</script>

<style>
</style>
